import { RuleId } from '../rules';

// Human-facing names and colors for the rules, shared by every view that names a technique
// (the deduction-graph explorer and the player profiles). The prose *explanations* stay in
// src/client/hints.ts — this is only the label.

export const ALL_RULE_IDS: RuleId[] = ['R2', 'R3', 'R4', 'R5', 'R6', 'R7', 'R8', 'R9'];

export const RULE_NAMES: Record<RuleId, string> = {
  R2: 'Line squeeze',
  R3: 'Color locked to line',
  R4: 'Line locked to color',
  R5: 'Pigeonhole (colors)',
  R6: 'Pigeonhole (lines)',
  R7: 'Region shadow',
  R8: 'Forced queen',
  R9: 'Paired shadow',
};

export const RULE_COLORS: Record<RuleId, string> = {
  R2: '#4c8dff', R3: '#22a06b', R4: '#12b5cb', R5: '#e8710a',
  R6: '#c2410c', R7: '#9333ea', R8: '#eab308', R9: '#e11d48',
};

export const ruleName = (r: string): string => RULE_NAMES[r as RuleId] ?? r;
export const ruleColor = (r: string): string => RULE_COLORS[r as RuleId] ?? '#888';
